import { getEndOfDay, getStartOfDay } from "../../../utils/utils";
import { SET_DATE_RANGE } from "./actionTypes";

const today = new Date();
const threeMonthsAgo = new Date(today);
threeMonthsAgo.setMonth(today.getMonth() - 3);

export const initialDateFilterState = {
  startDate: getStartOfDay(threeMonthsAgo),
  endDate: getEndOfDay(today),
};

export default function dateFilterReducer(
  state = initialDateFilterState,
  action
) {
  switch (action.type) {
    case SET_DATE_RANGE:
      return {
        ...state,
        startDate: getStartOfDay(action.payload.startDate),
        endDate: getEndOfDay(action.payload.endDate),
      };
    default:
      return state;
  }
}
